<div class="surface-card p-4 shadow-2 border-round">
  <ng-template [ngIf]="isLoadingResults">
    <app-loading></app-loading>
</ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroPratica" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICA <b>{{filtroPratica}}</b> DEL <b>BANDO 2</b> IN FASE <i>2</i></span>

        <span *ngIf="!isPresidioTIM && !filterIsSet && !filtroImpresa" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i></span>
        <span *ngIf="!isPresidioTIM && filtroInLavorazione" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> IN LAVORAZIONE</span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && filtroImpresa && !filtroStatoFlowdy && !filtroStatoAttivazione" class="text-l font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}}</b></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && filtroImpresa && filtroStatoAttivazione" class="text-l font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}} </b><u>{{statoAttivazione}}</u></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && !filtroImpresa && filtroStatoAttivazione" class="text-l font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> E STATO ATTIVAZIONE <u>{{filtroStatoAttivazione}}</u></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && filtroImpresa && filtroStatoFlowdy" class="text-l font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> DELL'IMPRESA <b>{{ragioneSocialeImpresa}} </b><u>{{filtroStatoFlowdy.toUpperCase()}}</u></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && !filtroImpresa && filtroStatoFlowdy && !filtroRegione" class="text-l font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> CON STATO <u>{{filtroStatoFlowdy.toUpperCase()}}</u></span>
        <span *ngIf="!isPresidioTIM && !filtroLotto && !filtroStatoInfratel && !filtroImpresa && filtroStatoFlowdy && filtroRegione" class="text-l font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> CON STATO <u>{{filtroStatoFlowdy.toUpperCase()}}</u> IN <u>{{filtroRegione.toUpperCase()}}</u></span>
        <span *ngIf="isPresidioTIM"class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE 2 IN CARICO AL PRESIDIO</span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroLotto"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> E LOTTO  <i>{{filtroLotto}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && !filtroLotto && filtroStatoInfratel && !filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> E STATO <i>{{filtroStatoInfratel.toUpperCase()}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroStatoInfratel && filtroLottoPerFase"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> E STATO <i>{{filtroStatoInfratel.toUpperCase()}}</i> E LOTTO  <i>{{filtroLottoPerFase}}</i></span>
        <span *ngIf="!isPresidioTIM && filterIsSet && filtroOda"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #3d64b3">PRATICHE DEL <b>BANDO 2</b> IN FASE <i>2</i> E ODA  <i>{{filtroOda}}</i></span>

          
         
      </div>
      <div class="flex justify-end md:justify-center">
      </div>
       
      <div class="flex justify-end md:justify-end">
        <button *ngIf="!isPM && !this.isDirigenteFirmaPacchetti && filterIsSet"
          pButton type="button" icon="pi pi-step-backward"
          pTooltip="Torna indietro" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#f0f4ff; color: #4f46e5; border-color: #4f46e5; font-size: 13px;"
          label="Indietro"
          (click)="goBack()" [disabled]="isLoadingResults || isDemo"
        ></button>
        <button *ngIf="!isPM && !this.isImpresa && !this.isPresidioTIM && !this.isDirigenteFirmaPacchetti"
          pButton type="button" icon="pi pi-reply pi-cloud-upload"
          pTooltip="Aggiorna le pratiche verificate dal supporto" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#E8FFB7; color: #000000; border-color: #000000; font-size: 13px;"
          label="Carica file Supporto"
          (click)="importaEsitiSupporto()" [disabled]="isLoadingResults || isDemo"
        ></button>
        <button *ngIf="!isPM && !this.isImpresa && !this.isDirigenteFirmaPacchetti"
          pButton type="button" icon="pi pi-reply"
          pTooltip="Aggiorna gli esiti della consegna ad Infratel" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#fffdea; color: #05542b; border-color: #05542b; font-size: 13px;"
          label="Carica esiti"
          (click)="importaEsitiConsegna()" [disabled]="isLoadingResults || isDemo"
        ></button>
        <button *ngIf="!isPM && praticheFiltrate && praticheFiltrate.length > 0"
          pButton type="button" icon="pi pi-cloud-download"
          pTooltip="Scarica export" tooltipPosition="top"
          class="font-['Poppins'] mr-3"
          style="background-color:#e3faf8; color: #0e192d; border-color: #3d64b3; font-size: 13px;"
          label="Scarica report"
          (click)="scaricaReportPratiche()" [disabled]="isLoadingResults"
        ></button>
       
      </div>
    </div>
 
 <!--[sortField]="'numero'" [sortOrder]="1"-->
            <div fxFlex="95%" class="mt-2">
                <p-table #praticheDT styleClass="p-datatable-sm" [value]="praticheFiltrate" dataKey="id" [(selection)]="selectedPratica"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="50" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[50,100,200]" responsiveLayout="scroll" [paginator]="true"
                currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                [globalFilterFields]="['cui','codiceInvio','bando','tipoSede','tipoSedeEffettiva','denominazione','regione','comune','codiceMiur','azienda', 'aziendaFase2', 'lotto',
                'numeroOda','statoFlowdyFase2','codiceStatoInfratelFase2', 'statoPF', 'numeroOdaFase2']"
                >
                <ng-template pTemplate="caption">
                  <div class="flex align-items-center md:justify-content-between justify-content-between ">
                  
                    <div class="flex justify-start md:justify-start" style="align-items: stretch;">
                      <span class="p-input-icon-left mr-2">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Cerca" (input)="filtraPratiche($event)" [disabled]="isLoadingResults" style="height: 2.5rem;" />
                      </span>
                      <p-multiSelect 
                      *ngIf="!filterIsSet && !isImpresa"
                      styleClass="fieldFilterControl" 
                      [options]="imprese"
                      [showToggleAll]="false"
                      optionLabel="ragioneSociale"
                      optionValue="id"
                      (onChange)="filtraPratiche($event)"
                      placeholder="Impresa"
                      [showClear]="false"
                      [filter]="false"
                      [showHeader]="false"
                      [(ngModel)]="filtroPratiche.impresa"
                    />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniTipoSedeBando2"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Tipo sede"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.tipo"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoInfratelFase2"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Stato Infratel"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.statoInfratel"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoFlowdyFase2"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Stato Pratica"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.statoPratica"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoPF"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Stato PF"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.statoProntofibra"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniRegioneBando2"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraPratiche($event)"
                        placeholder="Regione"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroPratiche.regione"
                      />
                      <button *ngIf="filterIsSet || filterTabellaIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                        style="background-color: #809cd4; border-color:#191a1b; color: #f9f9f9;font-size: 13px;" (click)="removeFilter()"
                        pTooltip="Rimuovi filtro" tooltipPosition="top" 
                      ></button>
                    </div>
                    <div class="flex justify-end md:justify-center">
                    </div>
                    <div class="flex justify-end md:justify-end">
                        <div class="flex align-items-center" *ngIf="!isPM && !filterIsSet">
                          <span class=" mr-2 text-900" style="font-size: small;">Mostra completate</span>
                          <p-inputSwitch [(ngModel)]="mostraPraticheCompletate" (ngModelChange)="onMostraCompletatiChange($event)"></p-inputSwitch>
                        </div>
                      </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                  <th class="text-center font-['Poppins']" style="font-size: 10px; width: 1%;">Azioni</th>
                  <th class="text-center font-['Poppins']" style="width: 1%"></th>
                  <th class="text-center font-['Poppins']" style="width: 1%"></th>
                  <th  pSortableColumn="cui" style="font-size: 10px; width: 20%;">
                  CUI
                  </th>
                  <th  pSortableColumn="cui" style="font-size: 8px; width: 20%;">
                    CODICE INVIO
                  </th>
                    <!-- <th  pSortableColumn="denominazione" style="font-size: 10px; width: 14%;">
                      SCUOLA
                    </th> -->
                    <th *ngIf="!isImpresa" class="text-center font-['Poppins']" style="font-size: 10px;width: 10%;">
                      IMPRESA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                        LOTTO
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      ODA
                    </th>
                    
                   <!--  <th pSortableColumn="codiceInvio" style="font-size: 10px; width: 5%;">
                      COD. INVIO
                    </th> -->
                    <th pSortableColumn="tipoSedeEffettiva" class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      Tipo
                   </th>
                   <th class="text-center" style="font-size: 10px; width: 2%;">
                    Coloc.
                  </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 4%;">
                      Stato F1
                   </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 2%;">
                    Stato PF
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                    Data PF
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 4%;">
                    Stato F2
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;;">
                    Stato Pratica
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 2%;">
                      LTE
                     </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      Permesso
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      Pec Ode
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      Appuntamento
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      Sollec.
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      Inst. Router
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;">
                      Sup. Tecnico
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      DATA INVIO
                    </th>
                    <th class="text-center font-['Poppins']" style="width: 1%"></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                      <td class="text-center" style="width: 10px;">
                        <button 
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text" 
                          (click)="openCaricaAzioni($event,row)">
                        </button> 
                      </td>
                      <td class="text-center" >
                       
                        <span *ngIf="checkAppuntamentoPassato(row)" 
                          class="material-symbols-outlined small-icon"        
                          [ngStyle]="{ 'color': '#C42021'}"
                          [pTooltip]="getTooltipAppuntamentoMancato(row)" tooltipPosition="top">
                          history_toggle_off
                        </span>
                      </td>
                     <!--   <td *ngIf="isImpresa" class="text-center" style="width: 10px;"> 
                        <button *ngIf="checkIfDeliverable(row) && checkIfButtonHasToBeShown(row)"
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-send" class="p-button-rounded p-button-text" 
                          (click)="consegnaPratica(row)" pTooltip="Consegna">
                        </button> 
                      </td>   -->
                      <td  class="text-center" >
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.filePingTestUploaded"            class="material-symbols-outlined small-icon" style="color:#033F63; cursor: pointer; " (click)="scaricaFile(row, 'PING_TEST', false)"      tooltipPosition="top"   pTooltip="Scarica file PING test">network_ping</span>
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.fileSpeedTestUploaded"           class="material-symbols-outlined small-icon" style="color:#28666E; cursor: pointer; " (click)="scaricaFile(row, 'SPEED_TEST', false)"     tooltipPosition="top"   pTooltip="Scarica file SPEED test">speed</span>
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.fotoCPEUploaded"                 class="material-symbols-outlined small-icon" style="color:#7C9885; cursor: pointer; " (click)="scaricaFotoCPE(row, false)"                tooltipPosition="top"   pTooltip="Scarica foto CPE">photo_camera</span>
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.fileVerbaleAttivazioneUploaded"  class="material-symbols-outlined small-icon" style="color:#6C234D; cursor: pointer; " (click)="scaricaDoc(row)"                           tooltipPosition="top"   pTooltip="Scarica Verbale">description</span>
                        <span *ngIf="(this.isImpresa || this.isPresidioSF) && checkShowActionIcons(row) && row.fileAltriUploadedFase2"          class="material-symbols-outlined small-icon" style="color:#6b6468; cursor: pointer; " (click)="scaricaFileAltri(row)"                     tooltipPosition="top"   pTooltip="Scarica file di tipo ALTRO">file_present</span>

                      </td>
                      <td > 
                        <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 8px; "
                        [pTooltip]="row.codiceMiur"
                        tooltipPosition="top">{{row.cui}}</span> 
                      </td>
                      <td class="text-left"> 
                        <span class="text-uppercase font-semibold font-['Poppins']" style=" font-size: 8px;">{{row.codiceInvio}}</span> 
                      </td>
                     <!--  <td > 
                        <span class="text-uppercase font-['Poppins']" style="font-weight: 500;font-size: 8px; "
                          [pTooltip]="row.indirizzo+' - '+ row.comune.toUpperCase()"
                          tooltipPosition="top"
                          >{{row.denominazione}}</span> 
                      </td> -->
                      <td *ngIf="!isImpresa" class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.aziendaFase2?row.aziendaFase2:row.azienda | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.2px;',
                                  'cursor': 'pointer',
                                }"
                                 (click)="filtraPerAzienda(row.aziendaFase2?row.aziendaFase2:row.azienda)"
                                 [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per azienda '+ (row.aziendaFase2?row.aziendaFase2:row.azienda)"
                                  tooltipPosition="top"
                            ></p-tag>
                       </td>
                    
                      <td class="text-center font-['Poppins']"> 
                        <p-tag [value]="row.lotto | uppercase"
                              [style]="{
                                'background-color': '#EBC66B' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '8px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                                  class="mr-1"
                                  (click)="filtraPerLotto(row.lotto)"
                                  [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per lotto '+row.lotto"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag *ngIf="row.numeroOda || row.numeroOdaFase2" [value]="row.numeroOdaFase2?row.numeroOdaFase2:row.numeroOda"
                              [style]="{
                                'background-color': '#78C0E0' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '8px',
                                'letter-spacing': '.3px;',
                              }"
                                  class="mr-1"
                                
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                     
                    
                      <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 8px;">{{row.tipoSede}}</span> </td>
                      <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 8px;">{{row.tipoSede}} ({{row.tipoSedeEffettiva}})</span> </td>
                      <td class="text-center font-['Poppins']"> 
                        <ng-container *ngIf="row.colocata">
                          <ng-container *ngIf="row.colocataRuolo === 'PRINCIPALE'; else secondaryIcon">
                            <i class="material-icons text-green-700 small-icon" tooltipPosition="top" pTooltip="Scuola PRINCIPALE">done_outline</i>
                        </ng-container>
                        <ng-template #secondaryIcon>
                           <i class="material-icons text-blue-700 small-icon" tooltipPosition="top" pTooltip="Scuola riferita a {{getPrincipaleDiUnaColocata(row)}}">done_all</i>
                         </ng-template>
                      </ng-container>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.codiceStatoInfratelFase1 | uppercase"
                                [style]="{
                                  'background-color': !row.showFase2 && row.codiceStatoInfratelFase1!=='1-1'?stiliService.getStatoInfratelColor(row.codiceStatoInfratelFase1):'#EE8434' ,
                                  'color': '#000000' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.3px;',
                                }"
                            ></p-tag>
                       </td>
                       <td class="text-center font-['Poppins']"> 
                        <span 
                          class="material-symbols-outlined small-icon"
                          [ngClass]="stiliService.getStatoPFIcon(row.statoPF)"
                          [ngStyle]="{ 'color': stiliService.getStatoPFColor(row.statoPF) }"
                          [pTooltip]="row.statoPF" tooltipPosition="top">
                          {{ stiliService.getStatoPFIcon(row.statoPF) }}
                        </span>
                       <!--  <p-tag
                                [value]="row.statoPF | uppercase"
                                [style]="{
                                  'background-color': stiliService.getStatoPFColor(row.statoPF) , IN ATTESA
                                  'color': '#000000' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '10px',
                                  'letter-spacing': '.3px;',
                                  
                                }"
                                
                            ></p-tag> -->
                       </td>
                       <td class="text-center font-['Poppins']"> 
                       <span class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 9px; ">{{ utilService.formattaDataPFDaTimestampFirestore(row)}}</span>
                       </td>
                       <td class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.codiceStatoInfratelFase2 | uppercase"
                                [style]="{
                                  'background-color': stiliService.getStatoInfratelColor(row.codiceStatoInfratelFase2) ,
                                  'color': '#000000' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.3px;',
                                  
                                }"
                                
                            ></p-tag>
                       </td>
                       <td class="text-center font-['Poppins']"> 

                        <span *ngIf="row.statoFlowdyFase2!='INSTALLAZIONE KO'"
                          class="material-symbols-outlined small-icon"
                          [ngClass]="stiliService.getMaterialIconStatoFlowdy(row.statoFlowdyFase2, 1)"
                          [ngStyle]="{ 'color': stiliService.getColoreIconaStatoFlowdy(row.statoFlowdyFase2,1) }"
                          [pTooltip]="row.statoFlowdyFase2 | uppercase" tooltipPosition="top">
                          {{ stiliService.getMaterialIconStatoFlowdy(row.statoFlowdyFase2, 1) }}
                        </span>
                      
                       </td>
                      <td class="text-center font-['Poppins'] small-icon">
                        <i class="pi"
                        [ngClass]="{ 'text-green-800 pi-check': row.backup}"></i>
                      </td> <!-- LTE-->
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.servePermessoEntePubblico"
                            class="material-symbols-outlined small-icon"
                            [ngClass]="stiliService.getIconaPermessoFase2(row)"
                            [ngStyle]="{ 'color': stiliService.getColoreIconaPermessoFase2(row) }"
                            [pTooltip]="row.permessoUploaded?'Numero protocollo '+row.numeroProtocolloPermessoFase2:'Permesso da caricare'" tooltipPosition="top">
                            {{ stiliService.getIconaPermessoFase2(row) }}
                          </span>
                      </td>
                      <td class="text-center font-['Poppins']">
                        <span  class="text-center  font-['Poppins']" style="font-size: 9px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataPecOde)}}</span>
                      </td>
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.dataAppuntamentoFase2" class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 9px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataAppuntamentoFase2)}}</span>
                      </td> <!-- appuntamento-->
                      <td></td> <!-- sollecito -->
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.installazioneRouterOk"
                        class="material-symbols-outlined small-icon"
                        [ngStyle]="{ 'color': '#034748' }"
                        [pTooltip]="getDataInstallazioneRouterTooltip(row)" tooltipPosition="top">
                        {{ 'task_alt' }}
                      </span>
                    <span *ngIf="(row.statoFlowdyFase2==='ATTIVAZIONE KO CPE' || row.statoFlowdyFase2==='ATTIVAZIONE KO FO' )&& !row.installazioneRouterOk"
                        class="material-symbols-outlined small-icon"
                        [ngStyle]="{ 'color': '#D85835' }"
                        [pTooltip]="getDataInstallazioneRouterTooltip(row)" tooltipPosition="top">
                        {{ 'error' }}
                      </span>
                      </td> <!-- router -->
                      <td class="text-center font-['Poppins']">
                        <span *ngIf="row.statoPF==='SEDE ATTIVATA' && row.dataConfermaTS"
                          class="material-symbols-outlined small-icon"
                          [ngStyle]="{ 'color': '#57C225' }"
                          [pTooltip]="getDataConfermaTSTooltip(row)" tooltipPosition="top">
                          {{ 'how_to_reg' }}
                        </span>
                        <span *ngIf="row.statoFlowdyFase2==='CONTROLLO TIM SUPPORT KO'" 
                        class="material-symbols-outlined small-icon"
                        [ngStyle]="{ 'color': '#EE4C0C' }"
                        [pTooltip]="getDataBocciaturaTSTooltip(row)" tooltipPosition="top">
                        {{ 'how_to_reg' }}
                      </span>
                       <!--  <img *ngIf="row.statoFlowdyFase2==='CONTROLLO TIM SUPPORT KO'" 
                        [pTooltip]="getDataBocciaturaTSTooltip(row)" tooltipPosition="top"
                          src="assets/icons/supporto_KO.png"
                          class="icon" 
                          width="18" 
                          height="18" /> -->
                       
                       <!--  <i *ngIf="row.statoFlowdyFase2==='CONTROLLO TIM SUPPORT KO'" class="pi"
                        [ngClass]="{ 'text-green-800 pi-check': row.backup}"></i>
                        <span 
                          class="material-symbols-outlined small-icon"
                          [ngStyle]="{ 'color': '#034748' }"
                          [pTooltip]="getDataConfermaTSTooltip(row)" tooltipPosition="top">
                          {{ 'how_to_reg' }}
                        </span> -->
                      </td> <!-- tecnical support -->
                      <td class="text-center font-['Poppins']">
                         <span *ngIf="row.dataInvioInfratelFase2 && row.codiceStatoInfratelFase2==='2-6'" class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 11px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataRispostaInfratelFase2)}}</span>
                        <span *ngIf="row.dataInvioInfratelFase2 && row.codiceStatoInfratelFase2!=='2-6'" class="text-center text-uppercase font-semibold font-['Poppins']" style="font-size: 11px; ">{{utilService.formattaDataDaTimestampFirestore(row.dataInvioInfratelFase2)}}</span>
                      </td> 
                      <td class="text-center" >
                        <span *ngIf="checkIfInfoAreAvailable(row)"
                          class="material-symbols-outlined small-icon"
                          [ngStyle]="{ 'color': row?.ntwFC ? '#00BA63' : '#F17300', 'cursor': 'pointer' }"
                           (click)="mostraInfo(row)" 
                           [pTooltip]="'Mostra info '+ (row?.ntwFC ? '(CON NTW FC)' : '(NO NTW FC)')" tooltipPosition="top">
                          info
                        </span> 
                      </td>
                      </tr>
                </ng-template>
              </p-table> 
              <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
            </div>
		</div>

    <p-dialog [(visible)]="showDettagliPratica" appendTo="body" [modal]="true" header="Dettagli Pratica {{selectedPratica?selectedPratica.cui:''}}" [style]="{width: '50vw'}" [breakpoints]="{'960px': '75vw', '640px': '90vw'}">
      <div class="p-fluid">
            <div class="grid">
              <div class="col-6 font-bold">SDF Principale:</div>
              <div class="col-6">{{ selectedPratica?.sdfPrincipale }}</div>
              
              <div class="col-6 font-bold">SDF Backup:</div>
              <div class="col-6">{{ selectedPratica?.sdfBackup }}</div>
              
              <div class="col-6 font-bold">TGU FTTO Principale:</div>
              <div class="col-6">{{ selectedPratica?.tguFttoPrincipale }}</div>
              
              <div class="col-6 font-bold">TGU FTTO Backup:</div>
              <div class="col-6">{{ selectedPratica?.tguFttoBackup }}</div>
              
              <div class="col-6 font-bold">TGU Giga Principale:</div>
              <div class="col-6">{{ selectedPratica?.tguGigaPrincipale }}</div>
              
              <div class="col-6 font-bold">TGU Giga Backup:</div>
              <div class="col-6">{{ selectedPratica?.tguGigaBackup }}</div>
              
              <div class="col-6 font-bold">Impresa FC:</div>
              <div class="col-6">{{ selectedPratica?.impresaFC }}</div>
              
              <div class="col-6 font-bold">NTW FC:</div>
              <div class="col-6">{{ selectedPratica?.ntwFC }}</div>
            </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-content-center border-top-1 surface-border pt-2 ">
          <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDettagliPratica = false" label="CHIUDI" class="p-button-outlined w-6 mr-2"></button>
        </div>
      </ng-template>
    </p-dialog>

 <p-dialog [(visible)]="showDeliverConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" [closable]="false" [showHeader]="false">
     <div class="flex flex-column align-items-center my-4">
        <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 border-circle mb-3" style="width:64px;height:64px">
            <i class="pi pi-send text-5xl"></i>
        </span>
        <div class="font-medium text-2xl text-900">CONSEGNA</div>
    </div>
    <p class="line-height-3 p-0 m-0">
       Confermi di voler consegnare la <strong>FASE 2</strong> della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
    </p>
    <ng-template pTemplate="footer">
        <div class=" border-top-1 surface-border pt-3 flex">
            <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeliverConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
            <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaConsegnaPratica()" label="CONFERMA" class="w-6 ml-2"></button>
        </div>
    </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showAnnullaConsegnaConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-orange-100 text-orange-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-send text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ANNULLA CONSEGNA</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler annullare la consegna della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showAnnullaConsegnaConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaAnnullamentoConsegnaPratica()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showEliminaFilePINGConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FILE</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare tutti i file del PING TEST della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFilePINGConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileCaricati(selectedPratica, 'PING_TEST')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showEliminaFileSPEEDConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FILE</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare tutti i file dello SPEED TEST della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileSPEEDConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileCaricati(selectedPratica, 'SPEED_TEST')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showEliminaFileFotoCPEConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-camera text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FOTO COPE</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare tutte le foto del CPE precedentemente caricate per la pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileFotoCPEConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiFileCaricati(selectedPratica, 'CPE')" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showEliminaFileAltriConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-file text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FILE</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare tutti gli altri file caricati per la pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaFileAltriConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="eliminataTuttiAltriFileCaricati(selectedPratica)" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-dialog [(visible)]="showSovrascritturaFotoCPEConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '60vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-exclamation-circle text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">CARICAMENTO FOTO CPE</div>
 </div>
 <p class="line-height-3 p-0 m-0" style="text-align: center;">
    Per la pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span> {{selectedPratica?selectedPratica.numeroFotoCPEUploaded==1?'è':'sono':''}} già {{selectedPratica?selectedPratica.numeroFotoCPEUploaded==1?'stata caricata':'state carticate':''}} <span style="font-weight: bold;">{{selectedPratica?selectedPratica.numeroFotoCPEUploaded:''}} foto del CPE</span>. Se si prosegue queste verranno sostituite.
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showSovrascritturaFotoCPEConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="caricaFotoCPE(selectedPratica)" label="PROSEGUI" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>
 
<p-dialog [(visible)]="showResettaPratica" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-orange-100 text-orange\-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="material-symbols-outlined small-icon" >reset_settings</i>
     </span>
     <div class="font-medium text-2xl text-900">RESET PRATICA</div>
 </div>
 <p class="line-height-3 p-0 m-0 ">
    Confermi di voler <u>RESETTARE</u> la <b>FASE 2</b> della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showResettaPratica = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaResetPratica()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showFase1Approvata" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-green-100 text-green-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="material-symbols-outlined small-icon" >verified</i>
     </span>
     <div class="font-medium text-2xl text-900">FASE 1 APPROVATA</div>
 </div>
 <p class="line-height-3 p-0 m-0 ">
    Confermi di voler comunicare l'approvazione  della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span> da parte di INFRATEL?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showFase1Approvata = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaApprovazioneFase1()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>  

<p-dialog [(visible)]="showEliminaShowFase2Confirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
  <div class="flex flex-column align-items-center my-4">
     <span class="flex align-items-center justify-content-center bg-red-100 text-red-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
         <i class="pi pi-eraser text-5xl"></i>
     </span>
     <div class="font-medium text-2xl text-900">ELIMINAZIONE FLAG SHOW FASE 2</div>
 </div>
 <p class="line-height-3 p-0 m-0">
    Confermi di voler eliminare il flag <b>show fase 2</b> della pratica <span style="font-weight: bold;">{{selectedPratica?selectedPratica.cui:''}}</span>?
 </p>
 <ng-template pTemplate="footer">
     <div class=" border-top-1 surface-border pt-3 flex">
         <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showEliminaShowFase2Confirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
         <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaEliminaShowFase2()" label="CONFERMA" class="w-6 ml-2"></button>
     </div>
 </ng-template>
</p-dialog>

<p-toast position="top-center"></p-toast>
<p-confirmDialog></p-confirmDialog>